@if ((loadingService.isLoading$ | async)) {
    <app-main-loading/>
}

<router-outlet/>

@if (newVersionConfirmationService.showDialog | async) {
    <app-new-version-confirmation-dialog/>
}
